import { render, staticRenderFns } from "./EntregaDomicilioContainer.vue?vue&type=template&id=718476cf&scoped=true"
import script from "./EntregaDomicilioContainer.vue?vue&type=script&lang=js"
export * from "./EntregaDomicilioContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718476cf",
  null
  
)

export default component.exports